export default {"src":"/_next/static/media/payment-method.e2bad6ec.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};